import { memo, PropsWithChildren } from 'react';

export const OptionsWrapper = memo(function _OptionsWrapper({ children }: PropsWithChildren) {
  return (
    <div className="absolute rounded-b-[20px] top-[23px] border-t-0 bg-i_dropdown_bg z-30 flex flex-col items-start overflow-y-auto w-full max-h-[100px] pt-2.5 border border-solid border-i_dropdown_border shadow-lg">
      {children}
    </div>
  );
});
